import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWalletArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "arrow-down",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M9 12.6C8.475 12.6 7.95 12.3975 7.5525 12L2.6625 7.11C2.445 6.8925 2.445 6.5325 2.6625 6.315C2.88 6.0975 3.24 6.0975 3.4575 6.315L8.3475 11.205C8.7075 11.565 9.2925 11.565 9.6525 11.205L14.5425 6.315C14.76 6.0975 15.12 6.0975 15.3375 6.315C15.555 6.5325 15.555 6.8925 15.3375 7.11L10.4475 12C10.05 12.3975 9.525 12.6 9 12.6Z",
			fill: "#7548F0"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			opacity: 0,
			d: "M18 0H0V18H18V0Z",
			fill: "#7548F0"
		})]
	})
});
export default SvgWalletArrowDown;
